import { FC, Fragment } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import EditorLink from 'lowcode/components/EditorLink';
import ProductHeader from '../ProductHeader';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps } from '@/components/MembersDay/type';
import { EuEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/EuEcoCredits';
import Button from '@/components/UI/Button';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import gtm from '@/utils/gtm';
import CommonCardA from '../CommonCardA';

// au有两种模式 5个产品和8个产品 分别2个&3个左右模块
const imgArr5 = [
    {
        // pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611386070/1_au.jpg',
        // h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611506623/1_au.jpg',
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054638185/RIVER%20Projpg.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1712054700556/RIVER%20Pro-MOjpg.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611397395/2_au.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611516927/2_au.jpg',
    },
];
const imgArr8 = [
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611408526/3_au.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611528327/3_au.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611419315/4_au.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611537380/4_au.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611430126/5_au.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711611546577/5_au.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713239310486/EcoFlow-AJRezac-26%201%20(1).png',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713239326810/EcoFlow-AJRezac-26%201%20(2).png',
    },
];

// au定制模块
const HotBundles: FC<IProductProps> = ({ module, icon, title, desc, id = 'activity-HotBundles' }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);
    const { isLogin } = useMembersStore();
    // 需要拆分成两个部分 左右图文 & 3个/row 两种格式
    const imgList = productList.length === 5 ? imgArr5 : imgArr8;
    const filterIndex = productList.length === 5 ? 2 : 4;
    const productListA = productList.filter((_item, index) => index < filterIndex);
    const productListB = productList.filter((_item, index) => index >= filterIndex);

    const handleDetail = (data: any) => {
        // if (isLogin) {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: title,
            product_name: data.title,
            price: data.memberPrice,
            tag: 'none',
            quantity: 1,
            button_name: t('product_price_buy_now'),
        });
        editorEventsBus.emit('ShopifyCart-add', data);
        // } else {
        //     gtm.push({
        //         event: 'uaEvent',
        //         event_name: 'ecocredits_join_login',
        //         list_name: title,
        //         button_name: t('product_price_buy_now'),
        //     });
        //     const pathname2 = location.pathname;
        //     location.href = `/${locale}/login?redirect=${pathname2}`;
        // }
    };

    return (
        <div className={`${styled.HotBundles}`} id={id}>
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className="product_box">
                {productListA.map((item, index) => (
                    <div key={item.variantId} className={`product_item ${index % 2 === 1 ? 'right' : ''}`}>
                        <div className="context">
                            <div className="context-info">
                                <EuEcoCredits />
                                <EditorLink className="name" href={item.productUrl} target="_blank">
                                    {item.title.replace(`(${t('product_price_member')})`, '')}
                                </EditorLink>
                                <p className="subtitle1">{item.subtitle1}</p>
                                <p className="subtitle2">{item.subtitle2}</p>
                            </div>
                            <div className="context-prices">
                                <p className="price">
                                    <span>{item.memberPrice2}</span>
                                    {Number(item.price) > Number(item.memberPrice) ? (
                                        <span className="member">{t('product_price_member')}</span>
                                    ) : (
                                        <span className="del">{item.compareAtPrice2}</span>
                                    )}
                                </p>
                                {Number(item.price) > Number(item.memberPrice) && (
                                    <p className="no_member_price">
                                        {item.price2}&nbsp;
                                        {t('product_price_non_member')}
                                        <span className="del">{item.compareAtPrice2}</span>
                                    </p>
                                )}

                                <p className="tools">
                                    {!item.checkoutNode ? (
                                        <EditorLink href={item.productUrl} target="_blank">
                                            <Button className="buy_button">{t('product_price_learn_more')}</Button>
                                        </EditorLink>
                                    ) : (
                                        <Button className="buy_button" onClick={() => handleDetail(item)}>
                                            {t('product_price_buy_now')}
                                        </Button>
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className="img">
                            <EditorImg pc={imgList[`${index}`]?.pc || item?.imageUrl} h5={imgList[`${index}`]?.h5 || item?.imageUrl} />
                            {item.discount && (
                                <div className="off">
                                    {item.discount}
                                    <span>{t('off')}</span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className={styled.BestSellers}>
                <div className={`members-day-inter`}>
                    {productListB.map((item) => {
                        return (
                            <Fragment key={item.variantId}>
                                <CommonCardA data={item} list_name={title} passLogin={true} />
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default HotBundles;
